/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Order_Events_By_TimeInputs */

const en_shortcut_keys_name_order_events_by_time = /** @type {(inputs: Shortcut_Keys_Name_Order_Events_By_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Order Events by Time`)
};

const fr_shortcut_keys_name_order_events_by_time = /** @type {(inputs: Shortcut_Keys_Name_Order_Events_By_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trier les evenements par temps`)
};

const de_shortcut_keys_name_order_events_by_time = /** @type {(inputs: Shortcut_Keys_Name_Order_Events_By_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ereignisse nach Zeit sortieren`)
};

const it_shortcut_keys_name_order_events_by_time = /** @type {(inputs: Shortcut_Keys_Name_Order_Events_By_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ordina gli eventi per ora`)
};

const ru_shortcut_keys_name_order_events_by_time = /** @type {(inputs: Shortcut_Keys_Name_Order_Events_By_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сортировать события по времени`)
};

const es_shortcut_keys_name_order_events_by_time = /** @type {(inputs: Shortcut_Keys_Name_Order_Events_By_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ordenar eventos por tiempo`)
};

const zh_cn2_shortcut_keys_name_order_events_by_time = /** @type {(inputs: Shortcut_Keys_Name_Order_Events_By_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`按时间排序事件`)
};

const ja_shortcut_keys_name_order_events_by_time = /** @type {(inputs: Shortcut_Keys_Name_Order_Events_By_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`時間順にイベントを並べ替える`)
};

const hi_shortcut_keys_name_order_events_by_time = /** @type {(inputs: Shortcut_Keys_Name_Order_Events_By_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`समय के अनुसार घटनाओं को क्रमबद्ध करें`)
};

const pt_pt2_shortcut_keys_name_order_events_by_time = /** @type {(inputs: Shortcut_Keys_Name_Order_Events_By_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ordenar eventos por horário`)
};

/**
* | output |
* | --- |
* | "Order Events by Time" |
*
* @param {Shortcut_Keys_Name_Order_Events_By_TimeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_order_events_by_time = /** @type {((inputs?: Shortcut_Keys_Name_Order_Events_By_TimeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Order_Events_By_TimeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_name_order_events_by_time(inputs)
	if (locale === "de") return de_shortcut_keys_name_order_events_by_time(inputs)
	if (locale === "it") return it_shortcut_keys_name_order_events_by_time(inputs)
	if (locale === "ru") return ru_shortcut_keys_name_order_events_by_time(inputs)
	if (locale === "es") return es_shortcut_keys_name_order_events_by_time(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_name_order_events_by_time(inputs)
	if (locale === "ja") return ja_shortcut_keys_name_order_events_by_time(inputs)
	if (locale === "hi") return hi_shortcut_keys_name_order_events_by_time(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_name_order_events_by_time(inputs)
	return en_shortcut_keys_name_order_events_by_time(inputs)
});